import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataService } from "../../../core/providers/data/data.service";
import { NotificationService } from "../../../core/providers/notification/notification.service";
import { CREATE_CONTACT_US } from "./contact-form.graphql";

@Component({
    selector: "vsf-contact-form",
    templateUrl: "./contact-form.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormComponent implements OnInit {
    contactForm: FormGroup;
    submitted = false;
    isOpen = false;

    constructor(
        private formBuilder: FormBuilder,
        private notificationService: NotificationService,
        private dataService: DataService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.contactForm = this.formBuilder.group({
            email: ["", [Validators.required, Validators.email]],
            phoneNumber: [""],
            message: ["", [Validators.required, Validators.minLength(1)]],
        });
    }

    openModal() {
        this.isOpen = true;
        this.cd.markForCheck();
    }

    closeModal() {
        this.isOpen = false;
        this.resetForm();
        this.cd.markForCheck();
    }

    resetForm() {
        this.contactForm.reset();
        this.submitted = false;
    }

    onSubmit() {
        if (this.contactForm.valid) {
            this.submitted = true;
            const input = {
                email: this.contactForm.get("email")?.value,
                phone: this.contactForm.get("phoneNumber")?.value || "",
                message: this.contactForm.get("message")?.value,
            };

            this.dataService.mutate(CREATE_CONTACT_US, { input }).subscribe({
                next: () => {
                    this.notificationService
                        .success(
                            "Thank you for your message! We'll get back to you soon."
                        )
                        .subscribe();
                    this.resetForm();
                    this.isOpen = false;
                },
                error: (error) => {
                    this.submitted = false;
                    this.notificationService.error(error.message).subscribe();
                },
            });
        } else {
            Object.keys(this.contactForm.controls).forEach((key) => {
                const control = this.contactForm.get(key);
                if (control?.errors) {
                    this.notificationService
                        .error(`Please check the ${key} field`)
                        .subscribe();
                }
            });
        }
    }
}
